import React, { Suspense } from 'react';
import { Container } from '@mui/material';
import { useSelector } from 'react-redux';
import { getSelectedAccount } from '../../../redux/selectedAccountSlice';
import CircularProgress from '@mui/material/CircularProgress';
import { useGetGatewaysByAccountQuery } from '../../../api/recalc/endpoints/gatewayApiSlice';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';

import GatewayDataGrid from '@/features/devices/components/gateways/GatewayDataGrid';

const GatewaysPage = () => {
  const selectedAccount = useSelector(getSelectedAccount);
  const {
    data: gateways,
    error,
    isLoading,
    isSuccess,
  } = useGetGatewaysByAccountQuery(selectedAccount?.AccountId);

  return (
    <Container maxWidth="xxl">
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '80vh',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <Fade in={isSuccess} timeout={500}>
          <Box>
            <GatewayDataGrid
              accountId={selectedAccount?.AccountId}
              gateways={gateways}
              isLoading={isLoading}
            />
          </Box>
        </Fade>
      </Suspense>
    </Container>
  );
};

export default GatewaysPage;
